import "../../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import { COLORS } from "./WsCarySpinner.es.js";
import { defineComponent, computed, openBlock, createElementBlock, createStaticVNode, createElementVNode as createBaseVNode } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = ["id"];
const _hoisted_3 = ["fill"];
const _hoisted_4 = {
  id: "Page-1",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
};
const _hoisted_5 = { id: "junglebug" };
const _hoisted_6 = { id: "Fill-1-Clipped" };
const _hoisted_7 = ["fill"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WsCarySpinner",
  props: {
    color: {
      type: String,
      default: "dark",
      validator: (value) => !!value && value in COLORS
    },
    width: {
      type: String,
      default: "80px"
    },
    height: {
      type: String,
      default: "30px"
    }
  },
  setup(__props) {
    const props = __props;
    const normalizedColor = computed(() => {
      return props.color === "dark" || props.color === "white" ? props.color : "default";
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", {
        class: "ws-cary-spinner",
        width: props.width,
        height: props.height,
        viewBox: "0 0 64 26",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _cache[1] || (_cache[1] = createStaticVNode('<defs data-v-2bfc88f6><linearGradient id="gradient_dark" x1="100%" y1="0%" x2="0%" y2="0%" data-v-2bfc88f6><stop offset="0" style="stop-color:rgba(44, 56, 67, 0);" data-v-2bfc88f6></stop><stop offset="50%" style="stop-color:rgba(44, 56, 67, 1);" data-v-2bfc88f6></stop><stop offset="100%" style="stop-color:rgba(44, 56, 67, 0);" data-v-2bfc88f6></stop></linearGradient><linearGradient id="gradient_white" x1="100%" y1="0%" x2="0%" y2="0%" data-v-2bfc88f6><stop offset="0" style="stop-color:rgba(255,255,255,0);" data-v-2bfc88f6></stop><stop offset="50%" style="stop-color:rgba(255,255,255,1);" data-v-2bfc88f6></stop><stop offset="100%" style="stop-color:rgba(255,255,255,0);" data-v-2bfc88f6></stop></linearGradient><linearGradient id="gradient_default" x1="100%" y1="0%" x2="0%" y2="0%" data-v-2bfc88f6><stop offset="0" style="stop-color:rgba(0,250,160,0);" data-v-2bfc88f6></stop><stop offset="50%" style="stop-color:#00FFA0;" data-v-2bfc88f6></stop><stop offset="100%" style="stop-color:rgba(0,250,160,0);" data-v-2bfc88f6></stop></linearGradient></defs>', 1)),
        createBaseVNode("pattern", {
          id: `pattern_${normalizedColor.value}`,
          x: "0",
          y: "0",
          width: "400%",
          height: "100%",
          patternUnits: "userSpaceOnUse"
        }, [
          createBaseVNode("rect", {
            x: "-100%",
            y: "0",
            width: "200%",
            height: "100%",
            fill: `url(#gradient_${normalizedColor.value})`,
            transform: "rotate(0)"
          }, _cache[0] || (_cache[0] = [
            createBaseVNode("animate", {
              attributeType: "XML",
              attributeName: "x",
              from: "-400%",
              to: "100%",
              dur: "1.25s",
              repeatCount: "indefinite"
            }, null, -1)
          ]), 8, _hoisted_3)
        ], 8, _hoisted_2),
        createBaseVNode("g", _hoisted_4, [
          createBaseVNode("g", _hoisted_5, [
            createBaseVNode("g", _hoisted_6, [
              createBaseVNode("path", {
                id: "Fill-1",
                fill: `url(#pattern_${normalizedColor.value})`,
                "fill-rule": "nonzero",
                d: "M10.6641 20.0838L17.9686 3.22916C18.5365 1.86109 19.8652\n               0.982178 21.3326 0.982178C22.8043 0.982178 24.0821 1.86109\n               24.6998 3.22916L31.9989 20.0838L39.3013 3.22916C39.8713 1.86109\n               41.1978 0.982178 42.6663 0.982178C44.137 0.982178 45.4158\n               1.86109 46.0335 3.22916L53.3315 20.0838L60.636 3.22916C61.2039\n               1.86109 62.5315 0.982178 64 0.982178V6.50359L56.8429\n               22.7227C56.1764 24.188 54.8499 25.0177 53.3315 25.0177C51.8154\n               25.0177 50.4867 24.188 49.8267 22.7227L42.6663 6.50359L35.5092\n               22.7227C34.8427 24.188 33.5151 25.0177 31.9989 25.0177C30.4817\n               25.0177 29.1541 24.188 28.493 22.7227L21.3326 6.50359L14.1755\n               22.7227C13.509 24.188 12.1825 25.0177 10.6641 25.0177C9.14796\n               25.0177 7.82037 24.188 7.1582 22.7227L0 6.50359V0.982178C1.46957\n               0.982178 2.74949 1.86109 3.36614 3.22916L10.6641 20.0838Z"
              }, null, 8, _hoisted_7)
            ])
          ])
        ])
      ], 8, _hoisted_1);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=WsCarySpinner.vue.es2.js.map
